import { styled } from "@mui/material";
import { CSSProperties } from "styled-components";

export const Container = styled("div")<{ bgImage: string; scale: number }>`
	position: relative;
	background-image: url(${(props) => props.bgImage});
	background-position: center center;
	background-size: contain;
	background-repeat: no-repeat;
	transform: scale(${(props) => props?.scale});
	border-radius: 16px;
	width: 343px;
	height: 612px;

	button:last-child {
		position: absolute;
		bottom: 24px;
		left: 50%;
		transform: translateX(-50%);
		width: 90%;
		max-width: 282px;
	}

	@media (orientation: landscape) {
		width: 744px;
		height: 319px;
		border-radius: 26px;

		button:last-child {
			bottom: 30px;
			max-width: 213px;
		}
	}
`;

export const ContributionsLeft = styled("p")<{ isPortrait: boolean }>`
	position: absolute;
	color: #ff6400;
	top: 18.5%;
	left: 48.8%;
	margin: 0;
	-webkit-text-stroke-width: 6px;
	-webkit-text-stroke-color: #fff;
	font-family: "Baloo";
	font-size: 42px;
	paint-order: stroke fill;
	line-height: 100%;
`;

export const timeStyle: CSSProperties = {
	top: 10,
	left: 10,
	fontSize: "1em"
};
